import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';
import ContractEditDrawer from 'components/Contracts/ContractEditDrawer';
import { formatDecimalForInput } from 'utils/utils';
import { showModal, hideModal } from "actions/modalActions";
import Avatars from 'components/Avatar/Avatars';
import DataTable from 'components/DataTable';
import { withTranslation } from 'react-i18next';
import * as rulesActions from 'actions/rulesActions';
import { contractsService } from "services";
import { errorFormating } from "utils/utils";

class ContractsList extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditContractDrawer = this.openEditContractDrawer.bind(this);
		this.openDeleteContractModal = this.openDeleteContractModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getContracts = this.getContracts.bind(this);
	}

	componentDidMount() {

	}

	closeModal() {
		this.props.hideModal()
	}

	getContracts() {
		this.props.getContracts({ variant: "detailed" });
	}

	openEditContractDrawer(contract) {
		this.props.showModal({
			open: true,
			width: 1000,
			content: ({ close, registerBeforeClose }) => (
				<ContractEditDrawer
					contract={contract}
					getContracts={this.getContracts}
					handleClose={close}
					registerBeforeClose={registerBeforeClose}
				/>
			),
			closeModal: this.closeModal,
		}, 'drawer')
	}

	openDeleteContractModal(idContract) {
		this.props.showModal({
			open: true,
			title: this.props.t('contracts.list.deleteContract'),
			style: { width: '400px' },
			message: this.props.t('contracts.list.deleteConfirmation'),
			deleteAction: () => this.confirmDelete(idContract),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(title, message) {
		this.props.showModal({
			open: true,
			title: title,
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idContract) => {
		const response = await contractsService.remove(idContract);

		if (!response.ok) {
			const textError = errorFormating(response);
			this.openAlertModal(
				this.props.t("contracts.list.deleteError"),
				textError.general ||
					textError.contract ||
					textError.id ||
					this.props.t("contracts.list.deleteError")
			);
		}
		else {
			this.getContracts();
			this.closeModal();
		}
	}

	cloneContract = async (idContract) => {
		const response = await contractsService.clone(idContract);
		// console.log(response);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(this.props.t("contracts.list.cloneError"), textError.id || this.props.t("contracts.list.cloneErrorMsg"));
		}
		else {
			this.getContracts();
			this.closeModal();
		}
	}

	employeesColumnCopy(contract) {
		let empleados_count = this.props.t("contracts.list.noEmployees");
		const employees_avatars = (contract.employees || []).filter((e) => e.enabled);
		const total_employees = employees_avatars.length;

		if (total_employees === 1) empleados_count = this.props.t("contracts.list.employeeCount_one");
		else if (total_employees > 1)
			empleados_count = this.props.t("contracts.list.employeeCount_other", { count: total_employees });

		return { employees_avatars, empleados_count, total_employees };
	}

	getContractColumns = () => [
		{
			key: "name",
			header: this.props.t("contracts.list.headerName"),
			render: (contract) => (
				<>
					<button
						type="button"
						className="btn-transparent"
						onClick={() => this.openEditContractDrawer(contract)}
					>
						{contract.name}
					</button>
					<span className="contract-description">{contract.description}</span>
				</>
			),
		},
		{
			key: "employees",
			header: this.props.t("contracts.list.headerEmployees"),
			render: (contract) => {
				const { employees_avatars, empleados_count, total_employees } =
					this.employeesColumnCopy(contract);
				return (
					<div className="avatar-container">
						{total_employees > 0 && (
							<Avatars employees={employees_avatars} />
						)}
						{empleados_count}
					</div>
				);
			},
		},
		{
			key: "hours",
			header: this.props.t("contracts.list.headerHoursWeek"),
			align: "right",
			render: (contract) =>
				`${formatDecimalForInput(contract.target_hours_per_week)} h`,
		},
		{
			key: "days",
			header: this.props.t("contracts.list.headerDaysWeek"),
			align: "right",
			render: (contract) =>
				`${contract.work_days_per_week} ${this.props.t("contracts.list.dayUnit", { count: contract.work_days_per_week })}`,
		},
		{
			key: "vacation",
			header: this.props.t("contracts.list.headerVacation"),
			render: (contract) =>
				`${contract.vacation_per_year} ${contract.vacation_type}`,
		},
	];

	render() {
		const contracts = this.props.contracts || [];

		return (
			<DataTable
				tableClassName="table-contracts table-hover"
				tableStyle={{ backgroundColor: "#ffffff" }}
				columns={this.getContractColumns()}
				rows={contracts}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t("common.noResults")}
				actionsColumn={{
					render: (contract) => (
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() => this.openEditContractDrawer(contract)}
								>
									{this.props.t("common.edit")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() => this.cloneContract(contract.id)}
								>
									{this.props.t("contracts.list.clone")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() => this.openDeleteContractModal(contract.id)}
								>
									{this.props.t("common.delete")}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					),
					className: "td-actions",
				}}
			/>
		);
	}
}


const mapStateToProps = (reducers) => {
	return reducers.rulesReducer;
};

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getContracts: (options) => dispatch(rulesActions.getContracts(options)),
})


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContractsList))
